































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Location } from "vue-router";
import { ROUTE_NAMES } from "../../router/routenames";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";
import ItemRefList from "../controls/ItemRefList.vue";

import { api as deskApi } from "../../store/modules/desk";
import { SignupUserPayload } from "../../store/modules/user/types";
import router from "../../router";
import { FriendRef, ItemRef } from "@dokogd/shared";

@Component({ components: { DoKoHtmlDialog, DoKoBtn, ItemRefList } })
export default class DoKoDialogWaitingForInvites extends Vue {
  loading = false;
  error = "";

  @Getter(deskApi.getters.getInvites, { namespace: deskApi.namespace })
  invites!: FriendRef[];

  @Action(deskApi.actions.join, { namespace: deskApi.namespace })
  joinDesk!: (payload: string) => Promise<string>;

  @Action(deskApi.actions.listenForInvites, { namespace: deskApi.namespace })
  listenForInvites!: () => Promise<void>;
  @Action(deskApi.actions.stopListenForInvites, {
    namespace: deskApi.namespace,
  })
  stopListenForInvites!: () => Promise<void>;

  onItemSelected(deskRef: ItemRef) {
    this.loading = true;
    this.joinDesk(deskRef.id)
      .then((deskId) => {
        console.log("joinDesk: done");
        this.$router.push({
          name: ROUTE_NAMES.DESK,
          params: {
            deskId,
          },
        });
      })
      .catch((err) => {
        console.error("joinDesk:failed", err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  createNewDesk() {
    this.$router.push({
      name: ROUTE_NAMES.CREATE_DESK,
    });
  }

  created() {
    this.listenForInvites().catch((err) => console.error(err));
  }
  beforeDestroy() {
    this.stopListenForInvites().catch((err) => console.error(err));
  }
}
